import { render, staticRenderFns } from "./PaymentResponse.vue?vue&type=template&id=0275e433&scoped=true"
import script from "./PaymentResponse.vue?vue&type=script&lang=js"
export * from "./PaymentResponse.vue?vue&type=script&lang=js"
import style0 from "./PaymentResponse.vue?vue&type=style&index=0&id=0275e433&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0275e433",
  null
  
)

export default component.exports